import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = ["disabled"]
const _hoisted_2 = {
  key: 2,
  class: "truncate"
}


import Spinner from "./Spinner.vue";
import { getButtonStyle } from "@/utils/buttonStyle";


export default /*@__PURE__*/_defineComponent({
  __name: 'RegularButton',
  props: {
    styleType: {},
    text: {},
    icon: {},
    iconPosition: {},
    pending: { type: Boolean },
    pendingText: {},
    wide: { type: Boolean },
    disabled: { type: Boolean },
    small: { type: Boolean }
  },
  setup(__props: any) {

const props = __props;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("button", {
    disabled: props.disabled || props.pending,
    class: _normalizeClass([
      'text-md py-2 px-5 border font-regular rounded-lg focus:outline-none focus:ring-2 focus:ring-offset-2 disabled:bg-opacity-50 disabled:pointer-events-none flex items-center',
      props.wide ? 'w-full' : 'w-fit',
      _unref(getButtonStyle)(props.styleType),
      props.small ? 'px-2.5 py-1.5 text-sm font-medium' : '',
    ])
  }, [
    (__props.pending)
      ? (_openBlock(), _createBlock(Spinner, {
          key: 0,
          horizontal: true,
          "custom-text": __props.pendingText
        }, null, 8, ["custom-text"]))
      : _createCommentVNode("", true),
    (__props.iconPosition === 'left' && __props.icon)
      ? (_openBlock(), _createElementBlock("i", {
          key: 1,
          class: _normalizeClass('fas fa-' + __props.icon + ' mr-2')
        }, null, 2))
      : _createCommentVNode("", true),
    (!__props.pending)
      ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(__props.text), 1))
      : _createCommentVNode("", true),
    (__props.iconPosition !== 'left' && __props.icon)
      ? (_openBlock(), _createElementBlock("i", {
          key: 3,
          class: _normalizeClass('fas fa-' + __props.icon + ' ml-2')
        }, null, 2))
      : _createCommentVNode("", true)
  ], 10, _hoisted_1))
}
}

})